import {
    Image,
    Container,
    Center,
    Button,
    Text,
    VStack,
  } from '@chakra-ui/react'
import { useEffect, useState } from 'react'



  export default function LoadingPage() {

    const [isRelaunch, setIsRelaunch] = useState(false)
    // Escape hatch: if boot takes abnormally long (dead radio, auth state
    // never resolving, Safari IndexedDB hangs), offer a manual reload instead
    // of an infinite astronaut. Deliberately NEVER auto-reloads — that could
    // loop on a persistent failure.
    const [showSlowHint, setShowSlowHint] = useState(false)

    useEffect(() => {
        const isRel = localStorage.getItem('isRelaunch')
        if(isRel == 'yes'){
            setIsRelaunch(true)
        }
        return () => {
            localStorage.setItem('isRelaunch', 'no')
        }
    }, [])

    useEffect(() => {
        const timer = setTimeout(() => setShowSlowHint(true), 20000)
        return () => clearTimeout(timer)
    }, [])

    return (
        <>
        <Center>
            <Container marginTop='30vh' >        
                <Image
                    src={isRelaunch ? require("../assets/img/rocket-launch.gif") : require("../assets/img/the-future-is-loading-transparent.gif")}
                    />
                {showSlowHint && (
                    <VStack spacing={3} mt={6}>
                        <Text color='gray.500' textAlign='center'>
                            This is taking longer than usual&hellip;
                        </Text>
                        <Button
                            colorScheme='green'
                            size='sm'
                            onClick={() => window.location.reload()}
                        >
                            Reload the Hub
                        </Button>
                    </VStack>
                )}
            </Container>
        </Center>
        </>
    )
  }
